import React from "react";

interface Column<T> {
    label: string;
    field: keyof T | string;
    render?: (value: any, row: T) => React.ReactNode;
}

interface TableContainerProps<T> {
    columns: Column<T>[];
    data: T[];
    isLoading?: boolean;
}

const TableContainer = <T,>({
    columns,
    data,
    isLoading = false,
}: TableContainerProps<T>) => {
    return (
        <div className="customDataTable !border-0  [&_>_div>table>thead]:!z-0 [&_>_div>table>thead>tr>th]:px-[0.45rem] [&_>_div>table>thead>tr>th>span>span]:!capitalize [&_>_div>table>tbody>tr>td]:!font-aeonikReg [&_>_div>table>tbody>tr>td]:capitalize [&_>_div>table>thead>tr>th]:py-2 [&_>_div>table>thead>tr>th]:!text-blackCol [&_>_div>table>thead>tr>th]:!font-aeonikBold [&_>_div>table>thead>tr>th>span]:!text-sm [&_>_div>table>tbody>tr>td]:!text-sm [&_>_div>table>thead>tr>th>span]:!justify-center  [&_>_div>table>tbody>tr>td]:px-[0.45rem] [&_>_div>table>tbody>tr>td]:py-2 [&_>_div>table>thead>tr>th]:!bg-theadBgCol [&_>_div>table>tbody>tr>td]:!text-blackCol">
            <table className="min-w-full border-0 relative">
                <thead className="h-[3.3125rem]">
                    <tr className=" [&_>_th]:px-[0.45rem] [&_>_th]:py-3 [&_>_th]:capitalize [&_>_th]:font-aeonikBold [&_>_th]:text-left [&_>_th]:text-blackCol [&_>_th]:text-sm [&_>_th]:bg-theadBgCol [&_>_th]:border-b [&_>_th]:border-[#e0e0e0] bg-theadBgCol">
                        {columns.map((col, index) => (
                            <th key={index}>
                                {col.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        // Render loading rows
                        Array.from({ length: 5 }).map((_, index) => (
                            <tr key={`loading-${index}`} className="animate-pulse">
                                {columns.map((_, colIndex) => (
                                    <td
                                        key={`loading-td-${colIndex}`}
                                        className="px-[0.45rem] py-2 bg-gray-200"
                                    >
                                        <div className="h-4 bg-gray-300 rounded"></div>
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : data.length === 0 ? (
                        // Render "No Records Found" row
                        <tr>
                            <td
                                colSpan={columns.length}
                                className="px-[0.45rem] py-2 text-center text-gray-500 border-b border-tableBorder"
                            >
                                No Records Found
                            </td>
                        </tr>
                    ) : (
                        // Render table rows
                        data.map((row, rowIndex) => (
                            <tr
                                key={rowIndex}
                                className=" [&_>_td]:!px-[0.45rem] [&_>_td]:!py-2 [&_>_td]:capitalize [&_>_td]:font-aeonikReg [&_>_td]:text-left [&_>_td]:border-b [&_>_td]:border-tableBorder [&_>_td]:text-[0.75rem]"
                            >
                                {columns.map((col, colIndex) => (
                                    <td key={colIndex}>
                                        {col.render
                                            ? col.render((row as any)[col.field], row)
                                            : (row as any)[col.field]}
                                    </td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default TableContainer;